import type {
  HistoryResponse,
  MappedHistory,
} from './type/account-status-monitor'

export function mapFollowHistoryResponse(
  response?: HistoryResponse,
): MappedHistory {
  const list = response?.list ?? []
  return {
    items: list.map((item) => ({
      followUpAt: item.operatedAt,
      followUpBy: item.operator,
      followUpContent: item.remark,
      followUpSource: item.source,
      followUpStatus: item.followStatus,
      id: item.id,
      recordId: item.changeLogId,
    })),
    total: list.length,
  }
}
